













































































































































































































































































































































































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import CoNavBar from '@/components/Molecules/co-navbar/CoNavBar.vue';
import CoBreadcrumbs from '@/components/Molecules/co-breadcrumbs/CoBreadcrumbs.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import setCustomColors from '@/customColors';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoPaywall from '@/components/Organisms/co-paywall/CoPaywall.vue';
import { get } from 'lodash';
import { hr } from 'date-fns/locale';
import { applyUserLocale, getPersistedUserLocale } from '@/utils/locale.js';

interface MenuItem {
    title: string;
    icon?: string;
    path?: string;
    hidden?: boolean;
    isNew?: boolean;
    items?: MenuItem[];
    featureFlag?: string;
}

export default {
    name: 'AdminBase',
    components: {
        CoNavBar,
        CoButton,
        CoBreadcrumbs,
        CoPill,
        CoLink,
        CoAlert,
        CoText,
        CoTippy,
        CoRoundButton,
        CoHeadline,
        CoPaywall,
    },
    data() {
        return {
            collapsed: false,
            adminMenuOpen: true,
            selectedMenu: null,
            menu: {
                statistics: false,
                space: false,
                community: false,
                booking: false,
                event: false,
                monetization: false,
            },
            skipNoSlider: false,
            spacePlanName: null,
            spaceApplicationFee: null,
            currentPath: '',
            featureStatus: {},
            menuItems: [
                {
                    title: 'labels.dashboard',
                    icon: 'graph-up',
                    path: '/admin/dashboard',
                    items: [
                        { title: 'labels.general', path: '/admin/dashboard/general' },
                        {
                            title: 'labels.revenue',
                            path: '/admin/dashboard/revenue',
                            featureFlag: 'frontend.admin-revenue-dashboard',
                        },
                        {
                            title: 'labels.checkins',
                            path: '/admin/dashboard/check-ins',
                            featureFlag: 'frontend.checkin-statistics.admin',
                        },
                    ] as MenuItem[],
                },
                {
                    title: 'labels.community',
                    icon: 'people',
                    path: '/admin/community',
                    items: [
                        { title: 'labels.members', path: '/admin/community/member/list' },
                        { title: 'labels.invitedmembers', path: '/admin/community/member/invitations' },
                        {
                            title: 'labels.membershipupgrades',
                            path: '/admin/community/member/upgrades',
                        },
                        {
                            title: 'labels.customfields',
                            path: '/admin/community/member/custom-fields',
                        },
                        { title: 'labels.administrators', path: '/admin/community/administrators' },
                        { title: 'labels.signupstrategies', path: '/admin/setup/signup-strategy' },
                    ] as MenuItem[],
                },
                {
                    title: 'labels.bookings',
                    icon: 'co-bookings',
                    path: '/admin/booking',
                    items: [
                        { title: 'labels.calendar', path: '/admin/booking/calendar' },
                        { title: 'labels.resources', path: '/admin/booking/resource' },
                        { title: 'labels.resourcecategories', path: '/admin/booking/categories' },
                        { title: 'labels.statistics', path: '/admin/booking/statistics' },
                    ] as MenuItem[],
                },
                {
                    title: 'labels.events',
                    icon: 'ticket-perforated',
                    path: '/admin/event',
                    items: [
                        { title: 'labels.events', path: '/admin/event/list' },
                        { title: 'labels.eventtypes', path: '/admin/event/types' },
                    ] as MenuItem[],
                },
                {
                    title: 'labels.channelsandpages',
                    icon: 'collection',
                    path: '/admin/pages',
                    items: [
                        { title: 'labels.pages', path: '/admin/pages/list' },
                        { title: 'labels.channels', path: '/admin/pages/channels' },
                    ] as MenuItem[],
                },
                {
                    title: 'labels.space',
                    icon: 'co-space',
                    path: '/admin/space',
                    items: [
                        { title: 'labels.administrators', path: '/admin/space/administrators' },
                        { title: 'labels.locations', path: '/admin/space/locations' },
                        {
                            title: 'labels.doorsandkeys',
                            path: '/admin/doorsnkeys',
                            featureFlag: 'frontend.access-management.admin',
                        },
                    ] as MenuItem[],
                },
                {
                    title: 'labels.monetization',
                    path: '/admin/monetization',
                    icon: 'co-monetization',
                    isNew: !this.$store?.state?.billingTurnedOn,
                },
                {
                    title: 'labels.settings',
                    path: '/admin/settings',
                    icon: 'gear',
                },
            ] as MenuItem[],
            showSubMenuItems: null as number | null,
            submenuTopPosition: null as number | null,
            paywallFeature: 'none',
        };
    },
    computed: {
        burgerButtonIcon() {
            if (this.adminMenuOpen) {
                return 'x';
            }
            return 'list';
        },
        // any menu is open
        anyMenuOpen() {
            return this.skipNoSlider;
            // return Object.values(this.menu).some((value) => value);
        },
    },
    watch: {
        // set the path parameter for conditional styling
        $route: {
            handler(to, from) {
                if (window.innerWidth < 768) this.adminMenuOpen = false;

                setCustomColors([
                    {
                        name: 'primary',
                        value: '#5100ff',
                    },
                    {
                        name: 'primary-dark',
                        value: '#3f00c6',
                    },
                    {
                        name: 'red',
                        value: '#fd6969',
                    },
                    {
                        name: 'text',
                        value: '#212529',
                    },
                ]);
                this.currentPath = to.path || '';
            },
            deep: true,
            immediate: true,
        },
        '$route.meta.breadcrumbs': {
            handler(value) {
                this.$store.commit('SET_BREADCRUMBS', value);
            },
            deep: true,
            immediate: true,
        },
        '$store.state.space': {
            // set the feature status for conditional alerts
            handler(value) {
                this.$set(this.featureStatus, 'booking', value.BookingOn || false);
                // EventsOff is inverted in the API payload, so the alert tracks the enabled state.
                this.$set(this.featureStatus, 'events', !value.EventsOff);
                // PagesOff is inverted in the API payload, so admins see the notice while management remains available.
                this.$set(this.featureStatus, 'pages', !value.PagesOff);
            },
            deep: true,
            immediate: true,
        },
        '$store.state.me.ID': {
            handler() {
                this.setUserLanguage();
            },
            immediate: true,
        },
    },
    created() {
        setCustomColors([
            {
                name: 'primary',
                value: '#5100ff',
            },
            {
                name: 'primary-dark',
                value: '#3f00c6',
            },
            {
                name: 'red',
                value: '#fd6969',
            },
            {
                name: 'text',
                value: '#212529',
            },
        ]);
        this.getPaymentState();
        this.getAdminSpaceSettings();
    },
    mounted() {
        if (this.$store && this.$store.state) {
            if (this.$store.state.space_configuration_admin) {
                this.spacePlanName = this.$store.state.space_configuration_admin.PlanName
                    ? this.$store.state.space_configuration_admin.PlanName.split(' ')[0]
                    : this.$t('labels.legacy');
                this.spaceApplicationFee = this.$store.state.space_configuration_admin.ApplicationFee;
            }
        }

        this.breadcrumbs = this.$route.meta.breadcrumbs;
        // add mouse leave event listener to desktop menu
        this.$refs.desktopmenu.addEventListener('mouseleave', this.handleMenuMouseLeave);

        this.$nextTick(function () {
            this.search = this.$route.query.term;
        });

        EventBus.$on(
            'PAYWALL',
            (payload) => {
                this.handlePaywallEvent(payload);
            },
            this
        );
    },
    // On destroy reset custom colors to default
    beforeDestroy() {
        EventBus.$off('PAYWALL');
        // destroy mouse leave event listener
        this.$refs.desktopmenu.removeEventListener('mouseleave', this.handleMenuMouseLeave);
        // restore custom colors
        setCustomColors([
            {
                name: 'primary',
                value: this.$store.state.space_configuration_admin.PrimaryColor || '#5100ff',
            },
            {
                name: 'primary-dark',
                value: this.$store.state.space_configuration_admin.PrimaryColor,
            },
            {
                name: 'red',
                value: this.$store.state.space_configuration_admin.SecondaryColor,
            },
            {
                name: 'text',
                value: this.$store.state.space_configuration_admin.TextColor,
            },
        ]);
    },
    methods: {
        setUserLanguage() {
            const currentUserLanguage = get(this.$store.state.me, 'Language', '');
            const persistedUserLanguage = getPersistedUserLocale();

            if (currentUserLanguage) {
                applyUserLocale(this, currentUserLanguage);
                return;
            }

            if (persistedUserLanguage) {
                applyUserLocale(this, persistedUserLanguage);
            }

            if (!get(this.$store.state.me, 'ID', null)) {
                return;
            }

            axios({
                method: 'PUT',
                url: '/me/language',
                withCredentials: true,
                data: {
                    language: this.$i18n.locale,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$store.commit('GETME', response.data);
                        applyUserLocale(this, response.data.Language || this.$i18n.locale, { persist: true });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePaywallEvent(payload) {
            if (typeof payload === 'string') {
                this.paywallFeature = payload;
            } else if (payload && typeof payload === 'object') {
                this.paywallFeature = payload.feature || payload.Feature || 'none';
            } else {
                this.paywallFeature = 'none';
            }

            const { paywall } = this.$refs;
            if (paywall) {
                paywall.show();
            }
        },
        // function check if there is a previous page and go back
        isTherePreviousPage() {
            if (this.$route.path === '/admin/dashboard/general') {
                return false;
            }
            return true;
        },

        back() {
            if (this.isTherePreviousPage()) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        goToUserInterace() {
            this.$router.push('/');
        },
        // getPaymentState - returns payment service readyness state
        getPaymentState() {
            axios({
                method: 'GET',
                url: '/user/account/billing/payment-state',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$store.commit('SET_PAYMENT_READY_STATE', response.data.ChargesEnabled);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAdminSpaceSettings() {
            axios({
                method: 'GET',
                url: '/admin/space/settings',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$store.commit('SET_SPACE_OBJECT_FOR_ADMIN', response.data);
                    }
                })
                .catch((error) => {});
        },
        handleDesktopItemClick(item: MenuItem, key: number, event: Event) {
            // store clicked menu item
            const menuItemClicked = event.currentTarget as HTMLElement;
            // get the y position of the clicked item
            const rect = menuItemClicked.getBoundingClientRect();
            this.submenuTopPosition = rect.top;
            // handle submenu display and navigation
            if (item.items && item.items.length) {
                this.showSubMenuItems = key; // show desktop submenu
            } else {
                this.showSubMenuItems = null;
                this.$router.push(item.path);
            }
        },
        openFeatureRequests() {
            window.open('https://roadmap.coapp.io/feature-requests', '_blank');
        },
        openHelpCenter() {
            window.open('https://help.coapp.io', '_blank');
        },
        handleMenuMouseLeave() {
            setTimeout(() => {
                this.showSubMenuItems = null;
            }, 200);
        },
    },
};
